import React, { createContext, useContext } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const ReCaptchaContext = createContext();

export const ReCaptchaProvider = ({ children }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LeoU_0rAAAAAB6kJSbr61QdhjQWUG9UBF1hUPvX"
      language="pl"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

const useReCaptcha = () => useContext(ReCaptchaContext);

export { useReCaptcha };
export default ReCaptchaProvider;
